// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/transfers/sdd_collections_orchestrator/mandates/firstparty/v1/list_mandates.proto

/* eslint-disable */

/** Status of an SDD mandate. */
export const ApiMandateStatus = {
  /** MANDATE_STATUS_UNSPECIFIED - Unspecified mandate status. */
  MANDATE_STATUS_UNSPECIFIED: "MANDATE_STATUS_UNSPECIFIED",
  /**
   * MANDATE_STATUS_APPROVED - Mandate is active and can be used for collections.
   * Either approved, imported or pending amendment mandates.
   */
  MANDATE_STATUS_APPROVED: "MANDATE_STATUS_APPROVED",
  /** MANDATE_STATUS_PENDING_SIGNATURE - Mandate is pending signature. */
  MANDATE_STATUS_PENDING_SIGNATURE: "MANDATE_STATUS_PENDING_SIGNATURE",
  /** MANDATE_STATUS_EXPIRED - Mandate has been suspended. */
  MANDATE_STATUS_EXPIRED: "MANDATE_STATUS_EXPIRED",
  /** MANDATE_STATUS_CANCELED - Mandate has been canceled. */
  MANDATE_STATUS_CANCELED: "MANDATE_STATUS_CANCELED",
  /** MANDATE_STATUS_DECLINED - Mandate has been declined. */
  MANDATE_STATUS_DECLINED: "MANDATE_STATUS_DECLINED",
} as const;

export type ApiMandateStatus = typeof ApiMandateStatus[keyof typeof ApiMandateStatus];

export namespace ApiMandateStatus {
  export type MANDATE_STATUS_UNSPECIFIED = typeof ApiMandateStatus.MANDATE_STATUS_UNSPECIFIED;
  export type MANDATE_STATUS_APPROVED = typeof ApiMandateStatus.MANDATE_STATUS_APPROVED;
  export type MANDATE_STATUS_PENDING_SIGNATURE = typeof ApiMandateStatus.MANDATE_STATUS_PENDING_SIGNATURE;
  export type MANDATE_STATUS_EXPIRED = typeof ApiMandateStatus.MANDATE_STATUS_EXPIRED;
  export type MANDATE_STATUS_CANCELED = typeof ApiMandateStatus.MANDATE_STATUS_CANCELED;
  export type MANDATE_STATUS_DECLINED = typeof ApiMandateStatus.MANDATE_STATUS_DECLINED;
}

export function apiMandateStatusFromJSON(object: any): ApiMandateStatus {
  switch (object) {
    case 0:
    case "MANDATE_STATUS_UNSPECIFIED":
      return ApiMandateStatus.MANDATE_STATUS_UNSPECIFIED;
    case 1:
    case "MANDATE_STATUS_APPROVED":
      return ApiMandateStatus.MANDATE_STATUS_APPROVED;
    case 2:
    case "MANDATE_STATUS_PENDING_SIGNATURE":
      return ApiMandateStatus.MANDATE_STATUS_PENDING_SIGNATURE;
    case 3:
    case "MANDATE_STATUS_EXPIRED":
      return ApiMandateStatus.MANDATE_STATUS_EXPIRED;
    case 4:
    case "MANDATE_STATUS_CANCELED":
      return ApiMandateStatus.MANDATE_STATUS_CANCELED;
    case 5:
    case "MANDATE_STATUS_DECLINED":
      return ApiMandateStatus.MANDATE_STATUS_DECLINED;
    default:
      return ApiMandateStatus.MANDATE_STATUS_UNSPECIFIED;
  }
}

export function apiMandateStatusToJSON(object: ApiMandateStatus): string {
  switch (object) {
    case ApiMandateStatus.MANDATE_STATUS_UNSPECIFIED:
      return "MANDATE_STATUS_UNSPECIFIED";
    case ApiMandateStatus.MANDATE_STATUS_APPROVED:
      return "MANDATE_STATUS_APPROVED";
    case ApiMandateStatus.MANDATE_STATUS_PENDING_SIGNATURE:
      return "MANDATE_STATUS_PENDING_SIGNATURE";
    case ApiMandateStatus.MANDATE_STATUS_EXPIRED:
      return "MANDATE_STATUS_EXPIRED";
    case ApiMandateStatus.MANDATE_STATUS_CANCELED:
      return "MANDATE_STATUS_CANCELED";
    case ApiMandateStatus.MANDATE_STATUS_DECLINED:
      return "MANDATE_STATUS_DECLINED";
    default:
      return "MANDATE_STATUS_UNSPECIFIED";
  }
}

/** Request for listing SDD mandates with pagination. */
export interface ApiListMandatesRequest {
  /** Optional sorting options. */
  readonly sort?:
    | ApiListMandatesRequestSort
    | null
    | undefined;
  /** Optional pagination options. */
  readonly pagination?:
    | ApiListMandatesRequestPagination
    | null
    | undefined;
  /** Filter options. */
  readonly filter?: ApiListMandatesRequestFilter | null | undefined;
}

/** Sorting options for the mandates. */
export interface ApiListMandatesRequestSort {
  /** The property to sort by. */
  readonly property: ApiListMandatesRequestSortProperty;
  /** The direction of sorting. */
  readonly direction: ApiListMandatesRequestSortDirection;
}

/** Enum for the property to sort by. */
export const ApiListMandatesRequestSortProperty = {
  /** PROPERTY_UNSPECIFIED - Unspecified property. */
  PROPERTY_UNSPECIFIED: "PROPERTY_UNSPECIFIED",
  /** PROPERTY_CLIENT_NAME - Sort by client name. */
  PROPERTY_CLIENT_NAME: "PROPERTY_CLIENT_NAME",
  /** PROPERTY_UNIQUE_MANDATE_REFERENCE - Sort by unique mandate reference. */
  PROPERTY_UNIQUE_MANDATE_REFERENCE: "PROPERTY_UNIQUE_MANDATE_REFERENCE",
  /** PROPERTY_CLIENT_IBAN_LAST_DIGITS - Sort by client IBAN last digits. */
  PROPERTY_CLIENT_IBAN_LAST_DIGITS: "PROPERTY_CLIENT_IBAN_LAST_DIGITS",
  /** PROPERTY_CREATED_AT - Sort by creation timestamp. */
  PROPERTY_CREATED_AT: "PROPERTY_CREATED_AT",
  /** PROPERTY_MANDATE_SIGNATURE_DATE - Sort by mandate signature date. */
  PROPERTY_MANDATE_SIGNATURE_DATE: "PROPERTY_MANDATE_SIGNATURE_DATE",
  /** PROPERTY_PROCESSING_SUBSCRIPTIONS_COUNT - Sort by processing subscriptions count. */
  PROPERTY_PROCESSING_SUBSCRIPTIONS_COUNT: "PROPERTY_PROCESSING_SUBSCRIPTIONS_COUNT",
  /** PROPERTY_MANDATE_STATUS - Sort by mandate status. */
  PROPERTY_MANDATE_STATUS: "PROPERTY_MANDATE_STATUS",
} as const;

export type ApiListMandatesRequestSortProperty =
  typeof ApiListMandatesRequestSortProperty[keyof typeof ApiListMandatesRequestSortProperty];

export namespace ApiListMandatesRequestSortProperty {
  export type PROPERTY_UNSPECIFIED = typeof ApiListMandatesRequestSortProperty.PROPERTY_UNSPECIFIED;
  export type PROPERTY_CLIENT_NAME = typeof ApiListMandatesRequestSortProperty.PROPERTY_CLIENT_NAME;
  export type PROPERTY_UNIQUE_MANDATE_REFERENCE =
    typeof ApiListMandatesRequestSortProperty.PROPERTY_UNIQUE_MANDATE_REFERENCE;
  export type PROPERTY_CLIENT_IBAN_LAST_DIGITS =
    typeof ApiListMandatesRequestSortProperty.PROPERTY_CLIENT_IBAN_LAST_DIGITS;
  export type PROPERTY_CREATED_AT = typeof ApiListMandatesRequestSortProperty.PROPERTY_CREATED_AT;
  export type PROPERTY_MANDATE_SIGNATURE_DATE =
    typeof ApiListMandatesRequestSortProperty.PROPERTY_MANDATE_SIGNATURE_DATE;
  export type PROPERTY_PROCESSING_SUBSCRIPTIONS_COUNT =
    typeof ApiListMandatesRequestSortProperty.PROPERTY_PROCESSING_SUBSCRIPTIONS_COUNT;
  export type PROPERTY_MANDATE_STATUS = typeof ApiListMandatesRequestSortProperty.PROPERTY_MANDATE_STATUS;
}

export function apiListMandatesRequestSortPropertyFromJSON(object: any): ApiListMandatesRequestSortProperty {
  switch (object) {
    case 0:
    case "PROPERTY_UNSPECIFIED":
      return ApiListMandatesRequestSortProperty.PROPERTY_UNSPECIFIED;
    case 1:
    case "PROPERTY_CLIENT_NAME":
      return ApiListMandatesRequestSortProperty.PROPERTY_CLIENT_NAME;
    case 2:
    case "PROPERTY_UNIQUE_MANDATE_REFERENCE":
      return ApiListMandatesRequestSortProperty.PROPERTY_UNIQUE_MANDATE_REFERENCE;
    case 3:
    case "PROPERTY_CLIENT_IBAN_LAST_DIGITS":
      return ApiListMandatesRequestSortProperty.PROPERTY_CLIENT_IBAN_LAST_DIGITS;
    case 4:
    case "PROPERTY_CREATED_AT":
      return ApiListMandatesRequestSortProperty.PROPERTY_CREATED_AT;
    case 5:
    case "PROPERTY_MANDATE_SIGNATURE_DATE":
      return ApiListMandatesRequestSortProperty.PROPERTY_MANDATE_SIGNATURE_DATE;
    case 6:
    case "PROPERTY_PROCESSING_SUBSCRIPTIONS_COUNT":
      return ApiListMandatesRequestSortProperty.PROPERTY_PROCESSING_SUBSCRIPTIONS_COUNT;
    case 7:
    case "PROPERTY_MANDATE_STATUS":
      return ApiListMandatesRequestSortProperty.PROPERTY_MANDATE_STATUS;
    default:
      return ApiListMandatesRequestSortProperty.PROPERTY_UNSPECIFIED;
  }
}

export function apiListMandatesRequestSortPropertyToJSON(object: ApiListMandatesRequestSortProperty): string {
  switch (object) {
    case ApiListMandatesRequestSortProperty.PROPERTY_UNSPECIFIED:
      return "PROPERTY_UNSPECIFIED";
    case ApiListMandatesRequestSortProperty.PROPERTY_CLIENT_NAME:
      return "PROPERTY_CLIENT_NAME";
    case ApiListMandatesRequestSortProperty.PROPERTY_UNIQUE_MANDATE_REFERENCE:
      return "PROPERTY_UNIQUE_MANDATE_REFERENCE";
    case ApiListMandatesRequestSortProperty.PROPERTY_CLIENT_IBAN_LAST_DIGITS:
      return "PROPERTY_CLIENT_IBAN_LAST_DIGITS";
    case ApiListMandatesRequestSortProperty.PROPERTY_CREATED_AT:
      return "PROPERTY_CREATED_AT";
    case ApiListMandatesRequestSortProperty.PROPERTY_MANDATE_SIGNATURE_DATE:
      return "PROPERTY_MANDATE_SIGNATURE_DATE";
    case ApiListMandatesRequestSortProperty.PROPERTY_PROCESSING_SUBSCRIPTIONS_COUNT:
      return "PROPERTY_PROCESSING_SUBSCRIPTIONS_COUNT";
    case ApiListMandatesRequestSortProperty.PROPERTY_MANDATE_STATUS:
      return "PROPERTY_MANDATE_STATUS";
    default:
      return "PROPERTY_UNSPECIFIED";
  }
}

/** Enum for sorting direction. */
export const ApiListMandatesRequestSortDirection = {
  /** DIRECTION_UNSPECIFIED - Default or undefined value. */
  DIRECTION_UNSPECIFIED: "DIRECTION_UNSPECIFIED",
  /** DIRECTION_ASC - Ascending order. */
  DIRECTION_ASC: "DIRECTION_ASC",
  /** DIRECTION_DESC - Descending order. */
  DIRECTION_DESC: "DIRECTION_DESC",
} as const;

export type ApiListMandatesRequestSortDirection =
  typeof ApiListMandatesRequestSortDirection[keyof typeof ApiListMandatesRequestSortDirection];

export namespace ApiListMandatesRequestSortDirection {
  export type DIRECTION_UNSPECIFIED = typeof ApiListMandatesRequestSortDirection.DIRECTION_UNSPECIFIED;
  export type DIRECTION_ASC = typeof ApiListMandatesRequestSortDirection.DIRECTION_ASC;
  export type DIRECTION_DESC = typeof ApiListMandatesRequestSortDirection.DIRECTION_DESC;
}

export function apiListMandatesRequestSortDirectionFromJSON(object: any): ApiListMandatesRequestSortDirection {
  switch (object) {
    case 0:
    case "DIRECTION_UNSPECIFIED":
      return ApiListMandatesRequestSortDirection.DIRECTION_UNSPECIFIED;
    case 1:
    case "DIRECTION_ASC":
      return ApiListMandatesRequestSortDirection.DIRECTION_ASC;
    case 2:
    case "DIRECTION_DESC":
      return ApiListMandatesRequestSortDirection.DIRECTION_DESC;
    default:
      return ApiListMandatesRequestSortDirection.DIRECTION_UNSPECIFIED;
  }
}

export function apiListMandatesRequestSortDirectionToJSON(object: ApiListMandatesRequestSortDirection): string {
  switch (object) {
    case ApiListMandatesRequestSortDirection.DIRECTION_UNSPECIFIED:
      return "DIRECTION_UNSPECIFIED";
    case ApiListMandatesRequestSortDirection.DIRECTION_ASC:
      return "DIRECTION_ASC";
    case ApiListMandatesRequestSortDirection.DIRECTION_DESC:
      return "DIRECTION_DESC";
    default:
      return "DIRECTION_UNSPECIFIED";
  }
}

/** Pagination options. */
export interface ApiListMandatesRequestPagination {
  /** Page number. Default is 1. */
  readonly page: number;
  /** Number of records per page. Default is 25. */
  readonly perPage: number;
}

/** Filter options. */
export interface ApiListMandatesRequestFilter {
  /** Filter by client id. If unset, no filtering on client_id is applied. */
  readonly clientId?:
    | string
    | null
    | undefined;
  /**
   * Only movements with the specified statuses will be returned.
   * The filter won't be applied if the array is empty.
   */
  readonly status: readonly ApiMandateStatus[];
}

/** Response containing the list of mandates and metadata. */
export interface ApiListMandatesResponse {
  /** List of mandates. */
  readonly mandates: readonly ApiListMandatesResponseMandate[];
  /** Pagination metadata. */
  readonly meta: ApiListMandatesResponsePagination | null;
}

/** Mandate information. */
export interface ApiListMandatesResponseMandate {
  /** Client identifier. */
  readonly clientId: string;
  /** Client name. */
  readonly clientName: string;
  /** Unique mandate reference. */
  readonly uniqueMandateReference: string;
  /** Client's (debtor) IBAN. */
  readonly clientIbanLastDigits: string;
  /** When the mandate was created in the system. */
  readonly createdAt: string;
  /** Date when the mandate was signed by the client. */
  readonly mandateSignatureDate: string;
  /**
   * Number of subscriptions in the following states:
   * pending_mandate_signature, scheduled, in_progress tied to this mandate.
   */
  readonly processingSubscriptionsCount: number;
  /** Current status of the mandate. */
  readonly status: ApiMandateStatus;
}

/** Pagination metadata for the mandates list. */
export interface ApiListMandatesResponsePagination {
  /** Current page number. */
  readonly currentPage: number;
  /** Total number of pages. */
  readonly totalPages: number;
  /** The next page number, or null if there is no next page. */
  readonly nextPage?:
    | number
    | null
    | undefined;
  /** The previous page number, or null if there is no previous page. */
  readonly prevPage?:
    | number
    | null
    | undefined;
  /** Total number of mandates. */
  readonly totalCount: number;
  /** Number of items per page. */
  readonly perPage: number;
}

export const ApiListMandatesRequest: MessageFns<ApiListMandatesRequest> = {
  fromJSON(object: any): ApiListMandatesRequest {
    return {
      sort: isSet(object.sort) ? ApiListMandatesRequestSort.fromJSON(object.sort) : null,
      pagination: isSet(object.pagination) ? ApiListMandatesRequestPagination.fromJSON(object.pagination) : null,
      filter: isSet(object.filter) ? ApiListMandatesRequestFilter.fromJSON(object.filter) : null,
    };
  },

  toJSON(message: ApiListMandatesRequest): unknown {
    const obj: any = {};
    if (message.sort !== undefined && message.sort !== null) {
      obj.sort = ApiListMandatesRequestSort.toJSON(message.sort);
    }
    if (message.pagination !== undefined && message.pagination !== null) {
      obj.pagination = ApiListMandatesRequestPagination.toJSON(message.pagination);
    }
    if (message.filter !== undefined && message.filter !== null) {
      obj.filter = ApiListMandatesRequestFilter.toJSON(message.filter);
    }
    return obj;
  },
};

export const ApiListMandatesRequestSort: MessageFns<ApiListMandatesRequestSort> = {
  fromJSON(object: any): ApiListMandatesRequestSort {
    return {
      property: isSet(object.property)
        ? apiListMandatesRequestSortPropertyFromJSON(object.property)
        : ApiListMandatesRequestSortProperty.PROPERTY_UNSPECIFIED,
      direction: isSet(object.direction)
        ? apiListMandatesRequestSortDirectionFromJSON(object.direction)
        : ApiListMandatesRequestSortDirection.DIRECTION_UNSPECIFIED,
    };
  },

  toJSON(message: ApiListMandatesRequestSort): unknown {
    const obj: any = {};
    if (message.property !== ApiListMandatesRequestSortProperty.PROPERTY_UNSPECIFIED) {
      obj.property = apiListMandatesRequestSortPropertyToJSON(message.property);
    }
    if (message.direction !== ApiListMandatesRequestSortDirection.DIRECTION_UNSPECIFIED) {
      obj.direction = apiListMandatesRequestSortDirectionToJSON(message.direction);
    }
    return obj;
  },
};

export const ApiListMandatesRequestPagination: MessageFns<ApiListMandatesRequestPagination> = {
  fromJSON(object: any): ApiListMandatesRequestPagination {
    return {
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      perPage: isSet(object.perPage) ? globalThis.Number(object.perPage) : 0,
    };
  },

  toJSON(message: ApiListMandatesRequestPagination): unknown {
    const obj: any = {};
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.perPage !== 0) {
      obj.perPage = Math.round(message.perPage);
    }
    return obj;
  },
};

export const ApiListMandatesRequestFilter: MessageFns<ApiListMandatesRequestFilter> = {
  fromJSON(object: any): ApiListMandatesRequestFilter {
    return {
      clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : null,
      status: globalThis.Array.isArray(object?.status)
        ? object.status.map((e: any) => apiMandateStatusFromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiListMandatesRequestFilter): unknown {
    const obj: any = {};
    if (message.clientId !== undefined && message.clientId !== null) {
      obj.clientId = message.clientId;
    }
    if (message.status?.length) {
      obj.status = message.status.map((e) => apiMandateStatusToJSON(e));
    }
    return obj;
  },
};

export const ApiListMandatesResponse: MessageFns<ApiListMandatesResponse> = {
  fromJSON(object: any): ApiListMandatesResponse {
    return {
      mandates: globalThis.Array.isArray(object?.mandates)
        ? object.mandates.map((e: any) => ApiListMandatesResponseMandate.fromJSON(e))
        : [],
      meta: isSet(object.meta) ? ApiListMandatesResponsePagination.fromJSON(object.meta) : null,
    };
  },

  toJSON(message: ApiListMandatesResponse): unknown {
    const obj: any = {};
    if (message.mandates?.length) {
      obj.mandates = message.mandates.map((e) => ApiListMandatesResponseMandate.toJSON(e));
    }
    if (message.meta !== undefined && message.meta !== null) {
      obj.meta = ApiListMandatesResponsePagination.toJSON(message.meta);
    }
    return obj;
  },
};

export const ApiListMandatesResponseMandate: MessageFns<ApiListMandatesResponseMandate> = {
  fromJSON(object: any): ApiListMandatesResponseMandate {
    return {
      clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : "",
      clientName: isSet(object.clientName) ? globalThis.String(object.clientName) : "",
      uniqueMandateReference: isSet(object.uniqueMandateReference)
        ? globalThis.String(object.uniqueMandateReference)
        : "",
      clientIbanLastDigits: isSet(object.clientIbanLastDigits) ? globalThis.String(object.clientIbanLastDigits) : "",
      createdAt: isSet(object.createdAt) ? globalThis.String(object.createdAt) : "",
      mandateSignatureDate: isSet(object.mandateSignatureDate) ? globalThis.String(object.mandateSignatureDate) : "",
      processingSubscriptionsCount: isSet(object.processingSubscriptionsCount)
        ? globalThis.Number(object.processingSubscriptionsCount)
        : 0,
      status: isSet(object.status)
        ? apiMandateStatusFromJSON(object.status)
        : ApiMandateStatus.MANDATE_STATUS_UNSPECIFIED,
    };
  },

  toJSON(message: ApiListMandatesResponseMandate): unknown {
    const obj: any = {};
    if (message.clientId !== "") {
      obj.clientId = message.clientId;
    }
    if (message.clientName !== "") {
      obj.clientName = message.clientName;
    }
    if (message.uniqueMandateReference !== "") {
      obj.uniqueMandateReference = message.uniqueMandateReference;
    }
    if (message.clientIbanLastDigits !== "") {
      obj.clientIbanLastDigits = message.clientIbanLastDigits;
    }
    if (message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.mandateSignatureDate !== "") {
      obj.mandateSignatureDate = message.mandateSignatureDate;
    }
    if (message.processingSubscriptionsCount !== 0) {
      obj.processingSubscriptionsCount = Math.round(message.processingSubscriptionsCount);
    }
    if (message.status !== ApiMandateStatus.MANDATE_STATUS_UNSPECIFIED) {
      obj.status = apiMandateStatusToJSON(message.status);
    }
    return obj;
  },
};

export const ApiListMandatesResponsePagination: MessageFns<ApiListMandatesResponsePagination> = {
  fromJSON(object: any): ApiListMandatesResponsePagination {
    return {
      currentPage: isSet(object.currentPage) ? globalThis.Number(object.currentPage) : 0,
      totalPages: isSet(object.totalPages) ? globalThis.Number(object.totalPages) : 0,
      nextPage: isSet(object.nextPage) ? globalThis.Number(object.nextPage) : null,
      prevPage: isSet(object.prevPage) ? globalThis.Number(object.prevPage) : null,
      totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
      perPage: isSet(object.perPage) ? globalThis.Number(object.perPage) : 0,
    };
  },

  toJSON(message: ApiListMandatesResponsePagination): unknown {
    const obj: any = {};
    if (message.currentPage !== 0) {
      obj.currentPage = Math.round(message.currentPage);
    }
    if (message.totalPages !== 0) {
      obj.totalPages = Math.round(message.totalPages);
    }
    if (message.nextPage !== undefined && message.nextPage !== null) {
      obj.nextPage = Math.round(message.nextPage);
    }
    if (message.prevPage !== undefined && message.prevPage !== null) {
      obj.prevPage = Math.round(message.prevPage);
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    if (message.perPage !== 0) {
      obj.perPage = Math.round(message.perPage);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
